<template>
  <div class="page-wrapper" >
    <Slider :journals="journals"/>
    <div class="filters sans-serif uppercase letter-space2">
      <!-- TEMPORARY DISABLED DUE TO SMALL NUMBER OF ARTICLES -->
      
      <!-- <section>
        <div v-if="selectedCategory" class="selected-category">
          {{ selectedCategory }}
        </div>
        <div v-else class="selected-category">
          ALL ARTICLES
        </div>
          <label for="category">CATEGORIES</label>
          <div class="select-wrapper">
            <select id="category" ref="select" v-model="selectedCategory" @change="handleCategoryChange">
              <option value=""></option>
              <option v-for="category in categories" :key="category" :value="category">{{ category }}</option>
            </select>
          </div>
      </section>
       -->
      <section>        
        <!-- <div>MOST RECENT</div> -->
      </section>
    </div>
    <article class="journal-index">
      <section v-for="(journal, index) in filteredJournals" :key="journal.id" :class="'section-' + ((index % 10) + 1)">
        <!-- <router-link :to="'journal/' + journal.journal.slug"> -->
          <!-- <router-link :to="'journal/' + journal.journal.slug"> -->
          <router-link
            v-if="journal?.journal?.slug"
            :to="`/journal/${journal.journal.slug}`"
          >
          <img :src="'/' + journal.journal.index_page_image">
          <div class="excerpt-wrapper">
            <h3>{{ journal.journal.title }}</h3>
            <div class="meta ">
              <span>{{ formatDate(journal.journal.date) }}</span>
              <strong style="padding: 0 10px;">&#8226;</strong>
              <span>{{ calculateReadingTime(journal.journal.content) }} MIN READ</span>
            </div>
          </div>
          <div class="shade"></div>
        </router-link>
      </section>
    </article>
  </div>
</template>

<style scoped lang="scss">
article.journal-index {
  width: 100vw;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  max-width: 1160px;

  > section {
    width: 100%;
    margin-bottom: 42px;
    position: relative;

    &:before {
      content: "";
      display: block;
      padding-bottom: 100%;
    }

    .shade {
      height: 35%;
    }

    // ≥1100px: alternate 3-2 layout based on position
    @media (min-width: 1100px) {
      // Every full cycle of 5: 3 items then 2 items
      // 3-item group: 5n+1, 5n+2, 5n+3
      &:nth-child(5n+1),
      &:nth-child(5n+2),
      &:nth-child(5n+3) {
        flex-basis: calc(33.333% - 13px);
      }

      // 2-item group: 5n+4, 5n+5
      &:nth-child(5n+4),
      &:nth-child(5n+5) {
        flex-basis: calc(50% - 13px);

        .shade {
          height: 55%;
          background: linear-gradient(to top, #f0eeea, #f0eeeadb, #f0eeea75, #f0eeea00);
        }
      }
    }

    // 768px–1099px: 2 items per row
    @media (max-width: 1099px) and (min-width: 768px) {
      flex-basis: calc(50% - 13px);

      .shade {
        height: 55%;
        background: linear-gradient(to top, #f0eeea, #f0eeeadb, #f0eeea75, #f0eeea00);
      }
    }

    // <768px: 1 item per row
    @media (max-width: 767px) {
      flex-basis: 100%;

      .shade {
        height: 55%;
        background: linear-gradient(to top, #f0eeea, #f0eeeadb, #f0eeea75, #f0eeea00);
      }
    }
  }
}

section {
  text-align: left;
  .shade {
    position: absolute;
    display: inline-block;
    bottom: 0;
    width: 100%;
    z-index: 1;
  }
.excerpt-wrapper {
    padding:  13px 20px 20px 25px;
    position: absolute;
    bottom: 0;
    height: 35%;
    width: 100%;
    display: flex; /* add flexbox to the container */
    flex-direction: column; /* set flex direction to column */
    justify-content: flex-end; /* align content to the bottom */
  }
  img {
    position: absolute;
  }
  h3, .meta {
    position: relative;
    bottom: 0;
    z-index: 2;
    margin-top: 0;
  }
  img {
    
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      }
  h3 {
      right: 0;
      left: 0;
      font-size: 1.2em;
      line-height: 1.5em;
      font-weight: 400;
      bottom: 10px;
  }
  .meta {
    width: 100%;
    margin-top: 0;
    span {
      display: inline-block;
      font-size: 0.8em;
      font-family:  freight-sans-pro, sans-serif;
    }
  }
}
.filters {
  height: 80px;
  position: relative;
  left: 0;
  top: -5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1160px;
  padding-left: calc((100vw - 1160px) / 2);

  .select-wrapper {
    position: relative;
    display: inline-block;
  }
  .selected-category {
    width: 150px;
  
  }
  select, label {
    padding: 0 40px 0 0;
  }

  .select-wrapper {
  position: relative;
  display: inline-block;
}

.select-wrapper select {
    display: block;
    width: 100%;
    font-size: 1em;
    /** for the dropdown indicator */
    appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: left;
    background-size: 1em;
    color: rgba(255, 0, 0, 0);
}

  div, select, label {
    display: inline-block;
    vertical-align: initial;
    color: white;
    text-transform: inherit;
    letter-spacing: inherit;
    font-family: inherit;
    font-size: 0.8em;
  }
  option, select {
    background-color: rgb(0, 0, 0);
    appearance: button !important;
  }

  section {
    // width: calc((100% - 30px) / 2); // subtract the width of the filters container and the space between sections
    @media (max-width: 600px) {
          width: auto;
          label {
            padding: 0;
          }
          .select-wrapper {
            width: 10px;
          }
    }
  }

  section:first-of-type {
    margin-right: 30px;
  }

  section:last-of-type {
    margin-left: 30px;
    text-align: right;
  }
}

@media (max-width: 1160px) {
  .filters, article {
    padding: 0 25px;
  }
  }
</style>

<script>
import Slider from '../components/Slider.vue';
export default {
  name: "Journals",
  components: {
          Slider
      },
  data() {
    return {
      journals: [],
      categories: [],
      selectedCategory: "",
    };
  },
  computed: {
    filteredJournals() {
      if (!this.selectedCategory) {
        return this.journals.filter(journal => {
        return journal.journal.status === 0;
      }).sort((a, b) => new Date(b.journal.date) - new Date(a.journal.date));
      }
      return this.journals.filter(
        (journal) => journal.journal_category.name === this.selectedCategory
      ).sort((a, b) => new Date(b.journal.date) - new Date(a.journal.date));
    },
  },
  methods: {
    handleCategoryChange(event) {
      this.selectedCategory = event.target.value;
    },
    formatDate(dateString) {
      const date = new Date(dateString)
      return date.toLocaleString('default', { month: 'long', year: 'numeric' })
    },
    calculateReadingTime(articleText) {
      if (!articleText) {
          return 0;
      }
      let wordCount = articleText.split(' ').length;
      let wordsPerMinute = 200;
      let readingTime = Math.ceil(wordCount / wordsPerMinute);
      return readingTime;
    },
    
  },
  mounted() {
     this.$axios.get("/api/journal-categories").then((response) => {
      this.journals = response.data;
      this.categories = [...new Set(response.data.map((journal) => journal.journal_category.name))];
      this.$emit("route-data-ready"); // tells App.vue to hide loader
    });
  },
}
</script>
